import * as auth from '../../auth/actions/auth.actions';
import * as account from '../actions/account.actions';
import {CodeType} from '../../staff/models/accounts.model';

// App State
export interface State {
  terms: string | null;
  privacy: string | null;
  generalSaved: boolean;
  generalLoading: boolean;
  clientProjects: Array<any> | null;
  verifyingPhone: boolean;
  tfaModalOpened: boolean;
  emailTakenError: string | null;
  acceptingLicense: boolean;
  changingPassword: boolean;
  licenseAgreement: string | null;
  phoneRequired2FA: boolean;
  removingPhone2FA: boolean;
  termsModalOpened: boolean;
  licenseModalOpened: boolean;
  privacyModalOpened: boolean;
  tfaConfModalOpened: boolean;
  tfaConfModalType: CodeType;
  tfaUri: string | null;
  emailChangeCanceled: boolean;
  phoneUpdateCanceled: boolean;
  removePhone2FAModal: boolean;
  verificationCalling: boolean;
  tfaVerificationError: string | null;
  licenseModalOpenedOnce: boolean;
  changePasswordModalOpened: boolean;
  changePasswordErrorMessage: string | null;
  licenseDeclinedModalOpened: boolean;
  emailVerificationModalOpened: boolean;
}

// Initial State
export const initialState: State = {
  terms: null,
  privacy: null,
  generalSaved: false,
  generalLoading: false,
  clientProjects: null,
  verifyingPhone: false,
  tfaModalOpened: false,
  emailTakenError: null,
  acceptingLicense: false,
  changingPassword: false,
  licenseAgreement: null,
  phoneRequired2FA: false,
  removingPhone2FA: false,
  termsModalOpened: false,
  licenseModalOpened: false,
  privacyModalOpened: false,
  tfaConfModalOpened: false,
  tfaConfModalType: null,
  tfaUri: null,
  emailChangeCanceled: false,
  phoneUpdateCanceled: false,
  removePhone2FAModal: false,
  verificationCalling: false,
  tfaVerificationError: null,
  licenseModalOpenedOnce: false,
  changePasswordModalOpened: false,
  changePasswordErrorMessage: null,
  licenseDeclinedModalOpened: false,
  emailVerificationModalOpened: false
};

// Export Reducer
export function reducer(state = initialState, action: account.Actions | auth.LogoutSuccess): State {
  switch (action.type) {

    // Toggle 2FA Modal
    case account.TOGGLE_2FA_MODAL:
      return { ...state, tfaModalOpened: !state.tfaModalOpened, phoneUpdateCanceled: false, tfaVerificationError: null };
    // Toggle 2FA Conf Modal
    case account.TOGGLE_2FA_CONF_MODAL:
      console.log('account.reducer.ts:reducer  TOGGLE_2FA_CONF_MODAL');
      return { ...state, tfaConfModalOpened: !state.tfaConfModalOpened, tfaConfModalType: 'phone', phoneUpdateCanceled: false };
    // Toggle 2FA Code Conf Modal
    case account.TOGGLE_2FA_CODE_CONF_MODAL:
      console.log('account.reducer.ts:reducer  TOGGLE_2FA_CODE_CONF_MODAL');
      return { ...state, tfaConfModalOpened: !state.tfaConfModalOpened, tfaConfModalType: 'code' };
    // Toggle 2FA Email Conf Modal
    case account.TOGGLE_2FA_EMAIL_CONF_MODAL:
      console.log('account.reducer.ts:reducer  TOGGLE_2FA_EMAIL_CONF_MODAL');
      return { ...state, tfaConfModalOpened: !state.tfaConfModalOpened, tfaConfModalType: 'email' };
    // Toggle License Agreement Modal
    case account.TOGGLE_LICENSE_MODAL:
      return { ...state, licenseModalOpened: !state.licenseModalOpened, licenseModalOpenedOnce: true };
    // Toggle Privacy Modal
    case account.TOGGLE_PRIVACY_MODAL:
      return { ...state, privacyModalOpened: !state.privacyModalOpened };
    // Toggle Terms Modal
    case account.TOGGLE_TERMS_MODAL:
      return { ...state, termsModalOpened: !state.termsModalOpened };
    // Toggle Change Password Modal
    case account.TOGGLE_CHANGE_PASSWORD_MODAL:
      return { ...state, changePasswordModalOpened: !state.changePasswordModalOpened };

    // Reset Basic Information
    case account.RESET_BASIC_INFORMATION:
      return { ...state, phoneUpdateCanceled: false, emailChangeCanceled: false, tfaVerificationError: null };

    // Email Verification
    case account.EMAIL_VERIFICATION:
    case account.RESTORE_EMAIL_VERIFICATION_FAIL:
      return { ...state, emailTakenError: null, emailChangeCanceled: false };

    // Email Verification Fail
    case account.EMAIL_VERIFICATION_FAIL:
      return { ...state, emailTakenError: action.payload, emailChangeCanceled: false };

    // Updating User Account
    case account.UPDATE_CLIENT_PHONE:
    case account.UPDATE_CLIENT_ACCOUNT:
      return { ...state, generalLoading: true, generalSaved: false, removePhone2FAModal: false, removingPhone2FA: false };

    // Update User Account Success
    case account.UPDATE_CLIENT_PHONE_SUCCESS:
    case account.UPDATE_CLIENT_ACCOUNT_SUCCESS:
    case account.UPDATE_CLIENT_2FA_CONFIGURATION_SUCCESS:
      return { ...state, generalLoading: false, generalSaved: true };

    // Update User Account MFA URI
    case account.UPDATE_CLIENT_2FA_URI:
      console.log('account.reducer.ts:reducer  UPDATE_CLIENT_2FA_URI  action.payload=', action.payload);
      return { ...state, tfaUri: action.payload };

    // Change Client Password
    case account.CHANGE_CLIENT_PASSWORD:
      return { ...state, changingPassword: true, changePasswordErrorMessage: null };

    // Change Client Password Success
    case account.CHANGE_CLIENT_PASSWORD_SUCCESS:
      return { ...state, changingPassword: false, generalLoading: false, generalSaved: true, changePasswordModalOpened: false };

    // Change Client Password Fail
    case account.CHANGE_CLIENT_PASSWORD_FAIL:
      return { ...state, changingPassword: false, changePasswordErrorMessage: action.payload };

    // Update User Phone 2FA
    case account.UPDATE_CLIENT_PHONE_2FA:
    case account.VERIFY_CLIENT_2FA_CONFIGURATION:
      return { ...state, generalSaved: false, generalLoading: true, verifyingPhone: true, tfaVerificationError: null };

    // Update User Phone 2FA Fail
    case account.UPDATE_CLIENT_PHONE_2FA_FAIL:
    case account.VERIFY_CLIENT_2FA_CONFIGURATION_FAIL:
    case account.UPDATE_CLIENT_PHONE_2FA_CALL_FAIL:
      return { ...state, verifyingPhone: false, tfaVerificationError: action.payload };

    // Disabling 2FA
    case account.UPDATE_CLIENT_2FA_CONFIGURATION:
      // tslint:disable-next-line:no-bitwise
      if (action.payload.factor_authentication & 0x01) return { ...state, generalLoading: true, generalSaved: false };
      else return state;

    // Update User Phone 2FA Success
    case account.UPDATE_CLIENT_PHONE_2FA_SUCCESS:
    case account.VERIFY_CLIENT_2FA_CONFIGURATION_SUCCESS:
      return {
        ...state,
        generalSaved: true,
        generalLoading: false,
        verifyingPhone: false,
        tfaModalOpened: false,
        tfaConfModalOpened: false
      };

    // Update User Phone 2FA Call
    case account.UPDATE_CLIENT_PHONE_2FA_CALL:
      return { ...state, verificationCalling: true };

    // Update User Phone 2FA Call Success
    case account.UPDATE_CLIENT_PHONE_2FA_CALL_SUCCESS:
      return { ...state, verificationCalling: false };

    // Update User Phone Canceled
    case account.UPDATE_CLIENT_PHONE_2FA_CANCEL:
      return { ...state, phoneUpdateCanceled: true };

    // Getting License Agreement
    case account.GET_LICENSE_AGREEMENT_SUCCESS:
      return { ...state, licenseAgreement: action.payload };

    case account.GET_PRIVACY_SUCCESS:
      return { ...state, privacy: action.payload };

    case account.GET_TERMS_SUCCESS:
      return { ...state, terms: action.payload };

    // Accepting License
    case account.LICENSE_AGREEMENT:
      return { ...state, generalLoading: true, generalSaved: false, acceptingLicense: true };
    // Accepting License Success
    case account.LICENSE_AGREEMENT_SUCCESS:
      return { ...state, generalLoading: false, generalSaved: true, acceptingLicense: false, licenseModalOpened: false };

    // Getting Client Projects
    case account.GET_CLIENT_PROJECTS_SUCCESS:
      return { ...state, clientProjects: action.payload };

    // Decline License
    case account.DECLINE_LICENSE:
      return { ...state, licenseModalOpened: false, licenseDeclinedModalOpened: true };
    // Close Declined License Modal
    case account.CLOSE_DECLINED_LICENSE_MODAL:
      return { ...state, licenseDeclinedModalOpened: false };

    // Toggle Phone Required Message Modal
    case account.TFA_PHONE_REQUIRED:
      return { ...state, phoneRequired2FA: !state.phoneRequired2FA };

    // Toggle Remove Phone With 2FA Enabled Modal
    case account.REMOVE_PHONE_2FA:
      return { ...state, removePhone2FAModal: !state.removePhone2FAModal };
    // Removing Phone With 2FA Enabled
    case account.UPDATE_CLIENT_2FA_CONFIGURATION_REMOVE_PHONE:
      return { ...state, removingPhone2FA: true };

    // Send Validation Code To Email Address
    case account.SEND_CODE_TO_EMAIL_ADDRESS:
      return { ...state, emailVerificationModalOpened: true, emailChangeCanceled: false, verifyingPhone: false };

    // Email Address Validation
    case account.VALIDATE_EMAIL_ADDRESS:
      return { ...state, generalLoading: true, generalSaved: false, verifyingPhone: true };

    // Email Address Validation Success
    case account.VALIDATE_EMAIL_ADDRESS_SUCCESS:
      return { ...state, generalLoading: false, generalSaved: true, emailVerificationModalOpened: false, verifyingPhone: false };

    // Close Email Address Validation Modal
    case account.CLOSE_VALIDATE_EMAIL_ADDRESS_MODAL:
      return { ...state, emailVerificationModalOpened: false };

    // Email Change Canceled
    case account.EMAIL_CHANGE_CANCELED:
      return { ...state, emailChangeCanceled: true };

    // User Logout
    case auth.LOGOUT_SUCCESS:
      return initialState;

    // Default
    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/app/my-account/reducers/account.reducer.ts